module.exports = __webpack_public_path__ + "img/img20.c0080f4a.jpg";